import type { Page } from '../';

export const hiddenSections = (page: Page) =>
  page.editorBlock.content.sections.some(section => !section.hidden);
